import React, { useState, useEffect } from "react";
import ScoreCard from "../../atoms/ScoreCard";

const OGScoreBody = () => {
  return (
    <div className="terms-body pt-16 ">
      <div className="flex  px-32 justify-between bg-grey-100">
        <div className="w-1/2 pt-20 pb-8">
          <div className="text-[55px] text-blue-800 w-72 font-bold">
            OG Score
          </div>
          <div className="pt-4 font-medium text-[#717171] text-base">
            Please read these Terms carefully before using this Website. By
            browsing, accessing and/or using this Website, you signify you have
            read and accept these Terms. If you do not agree to these Terms,
            please exit our Website and refrain from any further use and/or
            access to our Website. You are responsible for your compliance with
            all applicable laws and regulations in any jurisdiction.
          </div>
        </div>
        <div className="mr-8 mt-2">
          <img src="/images/og-score.svg" alt="contact us" />
        </div>
      </div>

      <div className="flex  px-32 pt-12 justify-between bg-white">
        <div className="mr-8 mt-2">
          <img src="/images/og-score-details.svg" alt="contact us" />
        </div>
        <div className="w-2/3 pt-20 pb-8">
          <div className="text-[55px] font-bold">In details About OG Score</div>
          <div className="pt-4 font-medium text-[#717171] text-base">
            Donec a eros justo. Fusce egestas tristique ultrices. Nam tempor,
            augue nec tincidunt molestie, massa nunc varius arcu, at scelerisque
            elit erat a magna. Donec quis erat at libero ultrices mollis. In hac
            habitasse platea dictumst. Vivamus vehicula leo dui, at porta nisi
            facilisis finibus. In euismod augue vitae nisi ultricies, non
            aliquet urna tincidunt. Integer in nisi eget nulla commodo faucibus
            efficitur quis massa. Praesent felis est, finibus et nisi ac,
            hendrerit venenatis libero. Donec consectetur faucibus ipsum id
            gravida.
          </div>
        </div>
      </div>
      <div className="flex  px-32 pt-12 justify-between bg-white">
        <div className="w-full pb-8">
          <div className="flex justify-center text-[55px] font-semibold">
            Types of credits
          </div>
          <h1 className="flex justify-center font-normal text-base text-[#717171]">
            Who is Nextcent suitable for?
          </h1>
        </div>
      </div>
      <div className="flex px-32 py-12 gap-x-24 justify-between bg-white text-sm text-[#717171]">
        <ScoreCard
          imageSrc="/images/GoldToken.svg"
          title="Gold"
          description="Our membership management software provides full automation of membership renewals and payments"
        />
        <ScoreCard
          imageSrc="/images/SilverToken.svg"
          title="Silver"
          description="Our membership management software provides full automation of membership renewals and payments"
        />
        <ScoreCard
          imageSrc="/images/BronzeToken.svg"
          title="Bronze"
          description="Our membership management software provides full automation of membership renewals and payments"
        />
      </div>
      {/* <div className="flex justify-between gap-20 bg-white mb-8 py-4 rounded-md">
      <div className="px-4" dangerouslySetInnerHTML={{ __html: privacyContent.pageContent }} />
      </div> */}
    </div>
  );
};

export default OGScoreBody;
